<!--
+------------------------------------------------------------------+
| Author: Jeffrey Thümann                                          |
| Component: DescendantTreePanel                                   |
| Section: components/Person                                       |
| Purpose: Reusable descendant tree panel with controls.           |
+------------------------------------------------------------------+
-->
<template>
    <ParentTreePanel :personId="personId" :initialGenerations="initialGenerations" :autoHeight="autoHeight"
        :autoHeightVerticalPadding="autoHeightVerticalPadding" :fitToContent="fitToContent"
        :cooperativeGestures="cooperativeGestures"
        :familyGroups="familyGroups" :initialRootPerson="initialRootPerson" treeType="descendants" />
</template>

<script>
import ParentTreePanel from '@/components/Person/ParentTreePanel.vue';

export default {
    name: 'DescendantTreePanel',
    components: {
        ParentTreePanel
    },
    props: {
        personId: {
            type: String,
            required: true
        },
        initialGenerations: {
            type: Number,
            default: 3
        },
        autoHeight: {
            type: Boolean,
            default: false
        },
        autoHeightVerticalPadding: {
            type: Number,
            default: 128
        },
        fitToContent: {
            type: Boolean,
            default: false
        },
        cooperativeGestures: {
            type: Boolean,
            default: true
        },
        familyGroups: {
            type: Array,
            default: () => []
        },
        initialRootPerson: {
            type: Object,
            default: null
        }
    }
};
</script>
